module.exports = __webpack_public_path__ + "img/winning_numbers.4eaa6720.png";